export default __webpack_public_path__ + "static/media/exposure_xl.15f63f38.jpg";